import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import SplashPage from './components/SplashPage';
import WelcomePage from './components/WelcomePage';
import Footer from './components/Footer';
import CreateWalletPage from './components/CreateWalletPage';
import ImportWalletPage from './components/ImportWalletPage';
import ConfirmPhrasePage from './components/ConfirmPhrasePage';
import SetPinPage from './components/SetPinPage';
import UnlockPage from './components/UnlockPage';
import HomePage from './components/HomePage';
import SendPage from './components/SendPage';
import SwapPage from './components/SwapPage';
import SettingsPage from './components/SettingsPage';
import SecurityPage from './components/SecurityPage';
import RecoveryPhrasePage from './components/RecoveryPhrasePage';
import ThemeSettingsPage from './components/ThemeSettingsPage';
import HelpCenterPage from './components/HelpCenterPage';
import AboutPage from './components/AboutPage';
import ReceivePage from './components/ReceivePage';
import ChangePinPage from './components/ChangePinPage';
import CustomTokens from './components/CustomTokens';
import AddCustomToken from './components/AddCustomToken';
import LoadingWallet from './components/LoadingWallet';
import TokenPage from './components/TokenPage';

const AppRoutes = () => {
  const location = useLocation();
  const hideFooterPaths = ['/splash', '/welcome', '/loading', '/create-wallet', '/import-wallet', '/confirm-phrase', '/set-pin', '/unlock'];
  const showFooter = !hideFooterPaths.includes(location.pathname);

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/splash" replace />} />
        <Route path="/splash" element={<SplashPage />} />
        <Route path="/welcome" element={<WelcomePage />} />
        <Route path="/create-wallet" element={<CreateWalletPage />} />
        <Route path="/import-wallet" element={<ImportWalletPage />} />
        <Route path="/confirm-phrase" element={<ConfirmPhrasePage />} />
        <Route path="/set-pin" element={<SetPinPage />} />
        <Route path="/unlock" element={<UnlockPage />} />
        <Route path="/loading" element={<LoadingWallet />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/receive" element={<ReceivePage />} />
        <Route path="/send" element={<SendPage />} />
        <Route path="/swap" element={<SwapPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/settings/security" element={<SecurityPage />} />
        <Route path="/settings/recovery-phrase" element={<RecoveryPhrasePage />} />
        <Route path="/settings/theme" element={<ThemeSettingsPage />} />
        <Route path="/settings/help" element={<HelpCenterPage />} />
        <Route path="/settings/about" element={<AboutPage />} />
        <Route path="/settings/change-pin" element={<ChangePinPage />} />
        <Route path="/custom-tokens" element={<CustomTokens />} />
        <Route path="/add-custom-token" element={<AddCustomToken />} />
        <Route path="/token/:symbol" element={<TokenPage />} />
      </Routes>
      {showFooter && <Footer />}
    </>
  );
};

export default AppRoutes; 